// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","graph5":"#217250","tertiary":"#BFD730","dot":"_1ALv","sm":"_3oL-","dot1":"_7K-4","colorChange":"_1pf-","dot2":"_3_TM","dot3":"Ds3E","shadow":"_3Ixy"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Loading/LoadingDots/LoadingDots.scss
// module id = yH2A
// module chunks = 0